import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Empty } from "@/components/Badges";
import { fmtDateTime } from "@/lib/format";

const PREFS = [["deadline", "Deadlines"], ["new_match", "New funding matches"], ["official_response", "Official responses"], ["renewal", "IP renewals"], ["reporting", "Grant reporting obligations"]];

export default function Alerts() {
  const { user, refresh } = useAuth();
  const [rows, setRows] = useState([]);
  const [prefs, setPrefs] = useState(user.alert_prefs || {});
  const load = () => api.get("/notifications").then(({ data }) => setRows(data));
  useEffect(() => {
    load();
  }, []);
  const toggle = async (k) => {
    const next = { ...prefs, [k]: prefs[k] === false };
    setPrefs(next);
    await api.put("/me/alert-prefs", { [k]: next[k] });
    refresh();
    toast.success("Alert preferences updated");
  };
  return (
    <div className="space-y-6 fade-up">
      <PageHeader title="Alerts" sub="In-platform alerts. Email alerts are not yet configured.">
        <button onClick={() => api.post("/notifications/read-all").then(load)} data-testid="mark-all-read-button" className="btn-ghost btn-sm">Mark all read</button>
      </PageHeader>
      <section className="card p-6" data-testid="alert-preferences">
        <h2 className="font-semibold text-[#0B192C]">Alert preferences</h2>
        <div className="mt-3 grid gap-2 sm:grid-cols-2">
          {PREFS.map(([k, l]) => (
            <label key={k} className="flex items-center gap-3 text-sm"><input type="checkbox" data-testid={`pref-${k}`} checked={prefs[k] !== false} onChange={() => toggle(k)} className="h-4 w-4 accent-[#0D9488]" />{l}</label>
          ))}
        </div>
      </section>
      {!rows.length && <Empty title="No alerts yet">Save funding opportunities and record official responses to receive alerts.</Empty>}
      <ul className="space-y-2" data-testid="notifications-list">
        {rows.map((n) => (
          <li key={n.id} className={`card p-4 ${n.read ? "opacity-70" : "border-l-4 border-l-[#0D9488]"}`}>
            <Link to={n.link || "#"} onClick={() => api.post(`/notifications/${n.id}/read`)} className="block">
              <p className="text-sm font-medium text-[#0B192C]">{n.title}</p>
              <p className="text-xs text-slate-500">{n.body} · {fmtDateTime(n.at)} · <span className="caption">{n.kind.replace("_", " ")}</span></p>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
